import React from "react";
import {
  CheckCircle2,
  CircleDashed,
  Clock3,
  XCircle,
} from "lucide-react";

const LABELS = {
  draft: "Preparing",
  awaiting_user_confirmation:
    "Awaiting confirmation",
  confirmed: "Confirmed",
  onramp_processing:
    "Payment processing",
  stablecoin_settlement_processing:
    "Payment received",
  offramp_processing:
    "Sending to recipient",
  compliance_review:
    "Being reviewed",
  manual_review:
    "Being reviewed",
  completed: "Completed",
  failed: "Failed",
  cancelled: "Cancelled",
};

export function TransferStatusCard({
  transfer,
}) {
  if (!transfer) {
    return null;
  }

  const status =
    transfer.status || "processing";

  const completed =
    status === "completed";

  const failed =
    status === "failed" ||
    status === "cancelled";

  const reviewing =
    status === "manual_review" ||
    status === "compliance_review";

  const Icon = completed
    ? CheckCircle2
    : failed
      ? XCircle
      : reviewing
        ? Clock3
        : CircleDashed;

  return (
    <div className="w-full max-w-[430px] rounded-3xl border border-[#0A4730]/10 bg-white p-4">
      <div className="flex items-center gap-3">
        <div
          className={`flex h-10 w-10 items-center justify-center rounded-full ${
            failed
              ? "bg-red-50 text-red-500"
              : completed
                ? "bg-[#C0F6B7]/60 text-[#0A4730]"
                : "bg-[#FFF7DA] text-[#9A7000]"
          }`}
        >
          <Icon
            size={19}
            className={
              !completed &&
              !failed &&
              !reviewing
                ? "animate-spin"
                : ""
            }
          />
        </div>

        <div>
          <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#0A2540]/40">
            Transfer status
          </p>

          <p className="mt-0.5 text-sm font-semibold text-[#0A2540]">
            {LABELS[status] ||
              "Processing"}
          </p>
        </div>
      </div>
    </div>
  );
}